<header class="page-header" role="banner">
  <div class="page-header__heading">
    <h1 class="page-header__title">{{ title() }}</h1>
    @if (subtitle()) {
      <p class="page-header__subtitle">{{ subtitle() }}</p>
    }
    <ng-content select="[meta]" />
  </div>
  <div class="page-header__actions" role="toolbar" aria-label="Ações da página">
    <ng-content select="[actions]" />
  </div>
</header>
